<template>
  <tab-options-style
      v-if="quoteTo==='cxTabs'"
      :options="options"
      :myid="myid"
  />
</template>

<script>
import tabOptionsStyle from "../../tabs/toolbars/tabs-options-style"
export default {
  components:{tabOptionsStyle},
  props: {
    options: {
      type: Object,
      required: true
    },
    myid: {
      type: Object,
      default: null
    },
  },
  computed:{
    quoteTo(){
      console.log("quoteTo", this.options.quoteTo)
      return this.options.quoteTo
    }
  }
}
</script>

<style></style>
